import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables. Please click "Connect to Supabase" button in the top right.');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'auth-storage',
    storage: {
      getItem: (key) => {
        const item = localStorage.getItem(key);
        if (!item) return null;

        const data = JSON.parse(item);
        const expiryTime = new Date(data.expiryTime || 0);
        
        // Check if 24 hours have passed since the last login
        if (expiryTime.getTime() < Date.now()) {
          localStorage.removeItem(key);
          return null;
        }
        
        return item;
      },
      setItem: (key, value) => {
        const data = JSON.parse(value);
        // Set expiry time to 24 hours from now
        data.expiryTime = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();
        localStorage.setItem(key, JSON.stringify(data));
      },
      removeItem: (key) => localStorage.removeItem(key)
    }
  }
});